import { useEffect, useState } from 'react';

import { API } from '../utils/apiBase';

/**
 * Live products from the admin-managed MongoDB catalogue.
 * Returns docs as: { id, name, tagline, price, compare_at, status, media, ... }.
 *
 * Status drives UX:
 *  - 'available'   → regular product detail, Add to cart
 *  - 'preorder'    → preorder detail, deposit flow
 *  - 'sold-out'    → visible but Add to cart disabled
 *  - 'coming-soon' → tile only, no detail page
 */
export const useStoreProducts = ({ status = null } = {}) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    setError(null);
    const cacheBust = Date.now();
    const url = `${API}/api/products?_=${cacheBust}${status ? `&status=${status}` : ''}`;
    fetch(url, { cache: 'no-store' })
      .then((r) => {
        if (!r.ok) throw new Error(`Failed to load products (${r.status})`);
        return r.json();
      })
      .then((d) => {
        if (!active) return;
        setProducts(d.items || []);
        setLoading(false);
      })
      .catch((err) => {
        if (!active) return;
        setError(err.message || 'Failed to load products');
        setLoading(false);
      });
    return () => { active = false; };
  }, [status]);

  return { products, loading, error };
};

export default useStoreProducts;
